import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "m-priceLevelFilter__container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "m-priceLevelFilter__name" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seatmapStore.getPriceLevelFilter, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item,
        class: _normalizeClass([{'-selected': _ctx.panelState.actions.selectFilter?.id === item.id}, "m-priceLevelFilter__item"]),
        onClick: ($event: any) => (_ctx.panelState.updateFilter(item))
      }, [
        _createElementVNode("span", {
          class: "m-priceLevelFilter__color",
          style: _normalizeStyle({ backgroundColor: item.color, color: item.textColor })
        }, null, 4),
        _createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1),
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.CurrencyHandler.displayPrimaryCurrency(item.startPrice)), 1),
          (_ctx.CurrencyHandler.isSecondaryCurrencyDisplayed)
            ? (_openBlock(), _createElementBlock("small", _hoisted_4, " (" + _toDisplayString(_ctx.CurrencyHandler.displaySecondaryCurrency(item.startPrice)) + ") +", 1))
            : _createCommentVNode("", true),
          (_ctx.seatmapStore.fees.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
            : _createCommentVNode("", true)
        ])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}